import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@jem-open/jem-ui";

const ALL_PROFILE_TYPES = "all";

const EmployeeFilterForm: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const currentValue = React.useMemo(() => {
    const params = new URLSearchParams(location.search);
    const val = params.get("isTemporary");
    if (val === "true") return "temporary";
    if (val === "false") return "permanent";
    return ALL_PROFILE_TYPES;
  }, [location.search]);

  const handleTemporaryFilterChange = (value: string): void => {
    const url = new URL(window.location.href);
    if (value === ALL_PROFILE_TYPES) {
      url.searchParams.delete("isTemporary");
    } else if (value === "temporary") {
      url.searchParams.set("isTemporary", "true");
    } else {
      url.searchParams.set("isTemporary", "false");
    }
    navigate(
      { pathname: location.pathname, search: url.search, hash: location.hash },
      { replace: true }
    );
  };

  return (
    <Select value={currentValue} onValueChange={handleTemporaryFilterChange}>
      <SelectTrigger className="w-[250px]">
        <SelectValue placeholder="All Profile Types" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL_PROFILE_TYPES}>All Profile Types</SelectItem>
        <SelectItem value="permanent">Permanent</SelectItem>
        <SelectItem value="temporary">Temporary</SelectItem>
      </SelectContent>
    </Select>
  );
};

export default EmployeeFilterForm;
